import React from "react";
import { Popup } from "semantic-ui-react";
import PropTypes from "prop-types";
import DocumentTypeItem from "./DocumentTypeItem";
import FileTypes from "../../modules/editor/FileTypes";
import Aux from "../utility/Aux";

/**
 * NewDocumentPopup: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Popover component that allows the user to select from a list
 * of file types to create a new document.
 *
 * @param {*} props
 */
const NewDocumentPopup = props => (
  <Popup
    trigger={props.trigger}
    content={
      <div>
        {props.canCreateDocuments ? (
          <Aux>
            {/**
             * Filetype: Simple Text
             * Allows the user to create simple text files
             */}
            <DocumentTypeItem
              documentType={FileTypes.SimpleText}
              documentTypeSelected={props.createDocument}
            />
            {/**
             * Filetype: Manuscript
             * Allows the user to compose interactive contetn
             */}
            <DocumentTypeItem
              documentType={FileTypes.Manuscript}
              documentTypeSelected={props.createDocument}
            />
          </Aux>
        ) : null}
        {/**
         * Filetype: Context
         * Allows the user to combine resources into a collection
         */}
        <DocumentTypeItem
          documentType={FileTypes.Context}
          documentTypeSelected={props.createContext}
        />
      </div>
    }
    basic
    hoverable
    position="bottom center"
    open={props.isOpen}
    onClose={props.onClose}
    onOpen={props.onOpen}
  />
);

NewDocumentPopup.propTypes = {
  /**
   * trigger: Node
   * Component, which triggers the popover to open
   * (e.g. a <Button>)
   */
  trigger: PropTypes.node.isRequired,

  /**
   * createDocument: (documentType) => ()
   * Fired when the user has chosen to create a new document
   */
  createDocument: PropTypes.func.isRequired,

  /**
   * createDocument: ()
   * Fired when the user has chosen to create a new context
   */
  createContext: PropTypes.func.isRequired,

  /**
   * isOpen: Boolean
   * True if the popup should be open
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * onClose: ()
   * Fired when the popup is dismissed
   */
  onClose: PropTypes.func.isRequired,

  /**
   * onOpen: ()
   * Fired when the popup should open
   */
  onOpen: PropTypes.func.isRequired,

  /**
   * canCreateDocuments: Boolean
   * True if the user should be able to create documents
   */
  canCreateDocuments: PropTypes.bool.isRequired
};

export default NewDocumentPopup;



// WEBPACK FOOTER //
// ./src/components/contextbar/NewDocumentPopup.js